import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ redirectTo = "/login", allowedRoles = [] }) => {
  const token = localStorage.getItem("token");

  if (!token) {
      return <Navigate to={redirectTo} replace />;
  }

  try {
      const decoded = jwtDecode(token); // Use the token directly
      const userRole = decoded["rol"];

      if (!allowedRoles.includes(userRole)) {
          return <Navigate to="/" replace />;
      }

      return <Outlet />;
  } catch (error) {
      console.error("Error decoding token:", error);
      localStorage.removeItem("token"); // Remove invalid token
      return <Navigate to={redirectTo} replace />;
  }
};

export default ProtectedRoute;
